import React from 'react'
import { loadingVariants } from '../styles'
import { Loading as CircularLoading } from '@tecsinapse/cortex-react'

const { container } = loadingVariants()

const Loading = () => (
  <div className={container()}>
    <CircularLoading className='text-primary-medium' />
  </div>
)

export default Loading
